// extracted by mini-css-extract-plugin
export var box = "_89-1";
export var checkboxRow = "_89-8";
export var checked = "_89-2";
export var descriptionSpacer = "_89-a";
export var disabled = "_89-3";
export var icon = "_89-6";
export var input = "_89-0";
export var labelSpacer = "_89-9";
export var medium = "_89-5";
export var small = "_89-4";
export var text = "_89-7";